import { Component, Input } from '@angular/core';

export enum ColorType {
  danger = 'danger',
  success = 'success',
  warning = 'warning',
  noColor = 'noColor'
}

export interface Legend {
  colorType: ColorType;
  label: string;
}

@Component({
  selector: 'app-legends',
  templateUrl: './legends.component.html',
  styleUrls: ['./legends.component.scss']
})
export class LegendsComponent {

  @Input() legends: Legend[] = [];

}
